<template>
  <master-page>
    <br/>
    <v-card>
      <v-card-title>
        <v-icon large left>mdi-clipboard-text-clock</v-icon>
        <span class="title font-weight-light">Controle de Ocorrências</span>
        <v-spacer/>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="click" v-on="on" @click="AbrirRelatorio()">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </template>
          <span>Relatório</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="click" class="" v-on="on" @click="NovaOcorrencia()" :disabled="!resumoBeneficiario.id">
              <v-icon style="color:white">mdi-plus</v-icon>
              <span style="color:white">Nova Ocorrência</span>
            </v-btn>
          </template>
          <span>Nova Ocorrência</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="click" v-on="on" @click="CarregarTudo()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Atualizar</span>
        </v-tooltip>
        <info/>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete v-model="beneficiarioId" :items="beneficiariosBusca" :loading="loadingBusca" :search-input.sync="buscaBeneficiario" hide-no-data clearable item-text="nome" item-value="id" label="Pesquisar beneficiário" placeholder="Nome, matrícula, CPF ou projeto" dense outlined @change="SelecionarBeneficiario">
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.nome }}</v-list-item-title>
                  <v-list-item-subtitle>Matrícula: {{ item.matricula || '-' }} | CPF: {{ item.cpfCnpj || '-' }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <section class="resumo-panel mb-4">
              <div class="resumo-foto">
                <v-img v-if="fotoBeneficiario" :src="fotoBeneficiario" max-height="120" contain/>
                <v-icon v-else size="72" color="#90a4ae">mdi-account-child</v-icon>
              </div>
              <div class="resumo-nome">{{ resumoBeneficiario.nome || 'Selecione um beneficiário' }}</div>
              <div class="resumo-linha">Matrícula: {{ resumoBeneficiario.matricula || '-' }}</div>
              <div class="resumo-linha">Nascimento: {{ DataNascimento(resumoBeneficiario) }}</div>
              <div class="resumo-linha">Responsável: {{ resumoBeneficiario.responsavel || '-' }}</div>
              <div class="mt-2">
                <v-chip v-for="projeto in resumoBeneficiario.projetos" :key="projeto.id" small class="mr-1 mb-1" :color="projeto.aberto ? 'green lighten-4' : 'red lighten-5'" :text-color="projeto.aberto ? 'green darken-4' : 'red darken-4'">
                  {{ projeto.codigoNome }}
                </v-chip>
                <span v-if="!resumoBeneficiario.projetos || resumoBeneficiario.projetos.length == 0" class="resumo-linha">Sem projetos ativos</span>
              </div>
              <v-btn v-if="resumoBeneficiario.id" small text color="primary" class="mt-2 px-0" @click="AbrirCadastroBeneficiario()">
                <v-icon small left>mdi-open-in-new</v-icon>
                Cadastro completo
              </v-btn>
            </section>

            <section class="tipo-panel">
              <div class="d-flex align-center mb-2">
                <span class="panel-title">Tipos de ocorrência</span>
                <v-spacer/>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small color="click" v-on="on" @click="NovoTipo()">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Novo tipo</span>
                </v-tooltip>
              </div>

              <v-list dense class="tipo-lista">
                <v-list-item v-for="tipo in tipos" :key="tipo.id">
                  <v-list-item-avatar size="22" :style="`background-color:${tipo.cor}`"/>
                  <v-list-item-content>
                    <v-list-item-title>{{ tipo.nome }}</v-list-item-title>
                    <v-list-item-subtitle>{{ tipo.ativo ? 'Ativo' : 'Inativo' }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="tipo-actions">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" @click="EditarTipo(tipo)">mdi-pencil</v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" @click="AlternarTipo(tipo)">{{ tipo.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline' }}</v-icon>
                      </template>
                      <span>{{ tipo.ativo ? 'Inativar' : 'Ativar' }}</span>
                    </v-tooltip>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </section>
          </v-col>

          <v-col cols="12" md="8">
            <v-row dense>
              <v-col cols="12" sm="3">
                <v-text-field v-model="filtro.dataInicial" type="date" label="Data inicial" dense outlined @change="CarregarOcorrencias()"/>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field v-model="filtro.dataFinal" type="date" label="Data final" dense outlined @change="CarregarOcorrencias()"/>
              </v-col>
              <v-col cols="12" sm="3">
                <v-select v-model="filtro.ocorrenciaTipoId" :items="tiposAtivos" item-value="id" item-text="nome" label="Tipo" clearable dense outlined @change="CarregarOcorrencias()"/>
              </v-col>
              <v-col cols="12" sm="3">
                <v-select v-model="filtro.gravidade" :items="gravidades" item-value="id" item-text="nome" label="Gravidade" clearable dense outlined @change="CarregarOcorrencias()"/>
              </v-col>
              <v-col cols="12">
                <v-select v-model="filtro.projetoId" :items="resumoBeneficiario.projetos" item-value="id" item-text="codigoNome" label="Projeto" clearable dense outlined @change="CarregarOcorrencias()"/>
              </v-col>
            </v-row>

            <v-alert v-if="!resumoBeneficiario.id" outlined type="info" dense>
              Selecione um beneficiário para visualizar o histórico.
            </v-alert>

            <div v-else class="timeline-list">
              <v-skeleton-loader v-if="loadingOcorrencias" type="list-item-three-line"/>
              <v-alert v-else-if="!!!ocorrencias" outlined type="info" dense>
                Nenhuma ocorrência encontrada.
              </v-alert>
              <div v-for="item in ocorrencias" :key="item.id" class="timeline-item">
                <div class="timeline-marker" :style="`background-color:${item.ocorrenciaTipo && item.ocorrenciaTipo.cor ? item.ocorrenciaTipo.cor : '#607D8B'}`"/>
                <div class="timeline-content">
                  <div class="d-flex align-center">
                    <strong>{{ new Date(item.dataOcorrencia).ddmmyyyy() }}</strong>
                    <v-chip small class="ml-2" :color="GravidadeCor(item.gravidade)" text-color="white" v-if="item.gravidade">{{ GravidadeNome(item.gravidade) }}</v-chip>
                    <v-spacer/>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" @click="VisualizarOcorrencia(item)">mdi-eye</v-icon>
                      </template>
                      <span>Visualizar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" @click="EditarOcorrencia(item)">mdi-pencil</v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" @click="ExcluirOcorrencia(item)">mdi-delete</v-icon>
                      </template>
                      <span>Excluir</span>
                    </v-tooltip>
                  </div>
                  <div class="timeline-title">{{ item.ocorrenciaTipo ? item.ocorrenciaTipo.nome : '-' }}</div>
                  <div class="timeline-subtitle">{{ item.projeto ? item.projeto.nome : 'Sem projeto' }} | {{ item.usuario ? item.usuario.nome : '-' }}</div>
                  <div class="timeline-text">{{ ResumoDescricao(item.descricao) }}</div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogTipo" max-width="620">
      <v-card>
        <v-card-title>Tipo de ocorrência</v-card-title>
        <v-card-text>
          <v-form ref="formTipo" v-model="validTipo" lazy-validation>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field v-model="tipo.nome" label="Nome" :rules="fieldRules" counter="120" maxlength="120" dense outlined/>
              </v-col>
              <v-col cols="12" md="4">
                <v-menu v-model="menuCorTipo" :close-on-content-click="false" offset-y max-width="290">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="tipo.cor" label="Cor" dense outlined readonly v-on="on">
                      <template v-slot:append>
                        <span class="color-field-preview" :style="`background-color:${tipo.cor || '#607D8B'}`"/>
                      </template>
                    </v-text-field>
                  </template>
                  <v-card>
                    <v-color-picker v-model="tipo.cor" mode="hexa" hide-mode-switch show-swatches swatches-max-height="120"/>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="tipo.descricao" label="Descrição" counter="500" maxlength="500" dense outlined/>
              </v-col>
              <v-col cols="12" md="4">
                <v-switch v-model="tipo.permiteAnexo" label="Permite anexo" dense/>
              </v-col>
              <v-col cols="12" md="4">
                <v-switch v-model="tipo.permiteGravidade" label="Permite gravidade" dense/>
              </v-col>
              <v-col cols="12" md="4">
                <v-switch v-model="tipo.ativo" label="Ativo" dense/>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="dialogTipo = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="SalvarTipo()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogOcorrencia" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
          <v-btn icon dark @click="dialogOcorrencia = false"><v-icon>mdi-close</v-icon></v-btn>
          <v-toolbar-title>Ocorrência do Beneficiário</v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items>
            <v-btn dark text @click="SalvarOcorrencia()" :disabled="!validOcorrencia">Salvar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-form ref="formOcorrencia" v-model="validOcorrencia" lazy-validation>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field v-model="ocorrencia.dataOcorrencia" type="date" label="Data ocorrência" :rules="fieldRules" dense outlined/>
              </v-col>
              <v-col cols="12" md="4">
                <v-select v-model="ocorrencia.ocorrenciaTipoId" :items="tiposAtivos" item-value="id" item-text="nome" label="Tipo ocorrência" :rules="fieldRules" dense outlined/>
              </v-col>
              <v-col cols="12" md="3">
                <v-select v-model="ocorrencia.projetoId" :items="projetosAbertos" item-value="id" item-text="codigoNome" label="Projeto" clearable dense outlined/>
              </v-col>
              <v-col cols="12" md="2" v-if="tipoSelecionado && tipoSelecionado.permiteGravidade">
                <v-select v-model="ocorrencia.gravidade" :items="gravidades" item-value="id" item-text="nome" label="Gravidade" dense outlined/>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="ocorrencia.descricao" label="Descrição" :rules="fieldRules" counter="1000" maxlength="1000" dense outlined/>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="ocorrencia.observacoes" label="Observações" counter="2000" maxlength="2000" dense outlined/>
              </v-col>
              <v-col cols="12" md="6" v-if="tipoSelecionado && tipoSelecionado.permiteAnexo">
                <v-chip v-if="ocorrencia.anexo" color="primary" close @click:close="DeletarDocumento(ocorrencia)">
                  <span @click="DownloadDocumento(ocorrencia)" style="cursor:pointer">{{ ocorrencia.anexo }}</span>
                </v-chip>
                <v-file-input v-else show-size v-model="arquivoCarregar" label="Anexo" dense outlined/>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDetalhe" max-width="820">
      <v-card>
        <v-card-title>Detalhe da ocorrência</v-card-title>
        <v-card-text v-if="ocorrenciaDetalhe">
          <p><strong>Data:</strong> {{ new Date(ocorrenciaDetalhe.dataOcorrencia).ddmmyyyy() }}</p>
          <p><strong>Projeto:</strong> {{ ocorrenciaDetalhe.projeto ? ocorrenciaDetalhe.projeto.nome : 'Sem projeto' }}</p>
          <p><strong>Tipo:</strong> {{ ocorrenciaDetalhe.ocorrenciaTipo ? ocorrenciaDetalhe.ocorrenciaTipo.nome : '-' }}</p>
          <p><strong>Gravidade:</strong> {{ GravidadeNome(ocorrenciaDetalhe.gravidade) || '-' }}</p>
          <p><strong>Descrição:</strong> {{ ocorrenciaDetalhe.descricao }}</p>
          <p><strong>Observações:</strong> {{ ocorrenciaDetalhe.observacoes || '-' }}</p>
          <p><strong>Usuário criação:</strong> {{ ocorrenciaDetalhe.usuario ? ocorrenciaDetalhe.usuario.nome : '-' }}</p>
          <p><strong>Criado em:</strong> {{ DataHora(ocorrenciaDetalhe.createdAt) }}</p>
          <p><strong>Alterado em:</strong> {{ DataHora(ocorrenciaDetalhe.updatedAt) }}</p>
          <p v-if="ocorrenciaDetalhe.anexo"><strong>Anexo:</strong> <a @click="DownloadDocumento(ocorrenciaDetalhe)">{{ ocorrenciaDetalhe.anexo }}</a></p>
          <v-divider class="my-3"/>
          <div class="panel-title mb-2">Histórico</div>
          <v-list dense>
            <v-list-item v-for="hist in historico" :key="`${hist.dataHora}-${hist.operacao}`">
              <v-list-item-content>
                <v-list-item-title>{{ hist.operacao }} - {{ hist.usuario }}</v-list-item-title>
                <v-list-item-subtitle>{{ DataHora(hist.dataHora) }} | {{ hist.descricao }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <cadastro-beneficiario v-model="dialogBeneficiario" :item="beneficiarioCadastro" @fechou="dialogBeneficiario = false" @salvou="SelecionarBeneficiario()"/>

    <v-overlay :value="loadingGeral">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>
  </master-page>
</template>

<script>
import BeneficiarioService from '@/core/services/projetos/BeneficiarioService';
import { BeneficiarioOcorrenciaService, OcorrenciaTipoService } from '@/core/services/projetos';
import { Beneficiario, BeneficiarioOcorrencia, OcorrenciaTipo } from '@/core/domain/projetos';

export default {
  data: () => ({
    beneficiarioService: new BeneficiarioService(),
    ocorrenciaService: new BeneficiarioOcorrenciaService(),
    tipoService: new OcorrenciaTipoService(),
    beneficiarioId: null,
    beneficiariosBusca: [],
    buscaBeneficiario: '',
    loadingBusca: false,
    resumoBeneficiario: { projetos: [] },
    fotoBeneficiario: '',
    tipos: [],
    ocorrencias: [],
    projetosAbertos: [],
    filtro: {
      dataInicial: '',
      dataFinal: '',
      ocorrenciaTipoId: null,
      gravidade: '',
      projetoId: null
    },
    tipo: new OcorrenciaTipo(),
    ocorrencia: new BeneficiarioOcorrencia(),
    beneficiarioCadastro: new Beneficiario(),
    ocorrenciaDetalhe: null,
    historico: [],
    arquivoCarregar: null,
    dialogTipo: false,
    dialogOcorrencia: false,
    dialogDetalhe: false,
    dialogBeneficiario: false,
    menuCorTipo: false,
    validTipo: true,
    validOcorrencia: true,
    loadingGeral: false,
    loadingOcorrencias: false,
    fieldRules: [v => !!v || 'Campo obrigatório'],
    gravidades: [
      { id: 'B', nome: 'Baixa' },
      { id: 'M', nome: 'Média' },
      { id: 'A', nome: 'Alta' }
    ]
  }),
  computed: {
    tiposAtivos(){
      return this.tipos.filter(x => x.ativo);
    },
    tipoSelecionado(){
      return this.tipos.find(x => x.id == this.ocorrencia.ocorrenciaTipoId);
    }
  },
  watch: {
    buscaBeneficiario(val){
      if(!val || val.length < 2 || this.loadingBusca)
        return;

      this.loadingBusca = true;
      this.ocorrenciaService.BuscarBeneficiario(val).then(
        res => this.beneficiariosBusca = res.data,
        err => this.MostrarErro(err)
      ).finally(() => this.loadingBusca = false);
    }
  },
  methods: {
    CarregarTudo(){
      this.CarregarTipos();
      if(this.resumoBeneficiario.id)
        this.CarregarOcorrencias();
    },
    AbrirRelatorio(){
      const routeLink = this.$router.resolve({
        name: 'relatorioControleOcorrencia',
        query: {
          beneficiarioId: this.resumoBeneficiario.id || null,
          dataInicial: this.filtro.dataInicial,
          dataFinal: this.filtro.dataFinal,
          ocorrenciaTipoId: this.filtro.ocorrenciaTipoId,
          gravidade: this.filtro.gravidade,
          projetoId: this.filtro.projetoId
        }
      });

      window.open(routeLink.href, '_blank');
    },
    CarregarTipos(){
      this.tipoService.ListarTudo().then(
        res => this.tipos = res.data,
        err => this.MostrarErro(err)
      );
    },
    SelecionarBeneficiario(){
      if(!this.beneficiarioId){
        this.resumoBeneficiario = { projetos: [] };
        this.fotoBeneficiario = '';
        this.ocorrencias = [];
        return;
      }

      this.loadingGeral = true;
      this.ocorrenciaService.ResumoBeneficiario(this.beneficiarioId).then(
        res => {
          this.resumoBeneficiario = res.data;
          this.projetosAbertos = this.resumoBeneficiario.projetos.filter(x => x.aberto);
          this.CarregarFotoBeneficiario();
          this.CarregarOcorrencias();
        },
        err => this.MostrarErro(err)
      ).finally(() => this.loadingGeral = false);
    },
    CarregarFotoBeneficiario(){
      this.fotoBeneficiario = '';
      this.beneficiarioService.Foto(this.resumoBeneficiario.id).then(
        res => this.fotoBeneficiario = res.data,
        () => this.fotoBeneficiario = ''
      );
    },
    CarregarOcorrencias(){
      if(!this.resumoBeneficiario.id)
        return;

      this.loadingOcorrencias = true;
      this.ocorrenciaService.ListarOcorrencias({
        beneficiarioId: this.resumoBeneficiario.id,
        dataInicial: this.filtro.dataInicial,
        dataFinal: this.filtro.dataFinal,
        ocorrenciaTipoId: this.filtro.ocorrenciaTipoId,
        gravidade: this.filtro.gravidade,
        projetoId: this.filtro.projetoId
      }).then(
        res => this.ocorrencias = res.data,
        err => this.MostrarErro(err)
      ).finally(() => this.loadingOcorrencias = false);
    },
    NovoTipo(){
      this.tipo = new OcorrenciaTipo();
      this.dialogTipo = true;
    },
    EditarTipo(tipo){
      this.tipo = new OcorrenciaTipo(tipo);
      this.dialogTipo = true;
    },
    PrepararPayload(model){
      const payload = Object.assign({}, model);
      delete payload.createdAt;
      delete payload.updatedAt;
      delete payload.CreatedAt;
      delete payload.UpdatedAt;
      return payload;
    },
    AlternarTipo(tipo){
      const model = new OcorrenciaTipo(tipo);
      model.ativo = !model.ativo;
      this.tipoService.Salvar(this.PrepararPayload(model)).then(
        () => this.CarregarTipos(),
        err => this.MostrarErro(err)
      );
    },
    SalvarTipo(){
      if(!this.$refs.formTipo.validate())
        return;

      this.tipoService.Salvar(this.PrepararPayload(new OcorrenciaTipo(this.tipo))).then(
        () => {
          this.$swal('Aviso', 'Operação realizada com sucesso!', 'success');
          this.dialogTipo = false;
          this.CarregarTipos();
        },
        err => this.MostrarErro(err)
      );
    },
    NovaOcorrencia(){
      this.ocorrencia = new BeneficiarioOcorrencia({ beneficiarioId: this.resumoBeneficiario.id });
      this.arquivoCarregar = null;
      this.dialogOcorrencia = true;
    },
    EditarOcorrencia(item){
      this.ocorrencia = new BeneficiarioOcorrencia(item);
      this.arquivoCarregar = null;
      this.dialogOcorrencia = true;
    },
    SalvarOcorrencia(){
      if(!this.$refs.formOcorrencia.validate())
        return;

      const tipo = this.tipoSelecionado;
      const model = new BeneficiarioOcorrencia(this.ocorrencia);
      model.beneficiarioId = this.resumoBeneficiario.id;
      if(!tipo || !tipo.permiteGravidade)
        model.gravidade = '';
      if(!tipo || !tipo.permiteAnexo)
        model.anexo = '';

      this.loadingGeral = true;
      this.ocorrenciaService.Salvar(this.PrepararPayload(model)).then(
        async res => {
          const id = res.data.id ? res.data.id : model.id;
          if(tipo && tipo.permiteAnexo && this.arquivoCarregar)
            await this.EnviarDocumento(id);

          this.$swal('Aviso', 'Operação realizada com sucesso!', 'success');
          this.dialogOcorrencia = false;
          this.CarregarOcorrencias();
        },
        err => this.MostrarErro(err)
      ).finally(() => this.loadingGeral = false);
    },
    ExcluirOcorrencia(item){
      this.$swal({
        title: 'Confirma a exclusão?',
        text: 'Essa operação não poderá ser desfeita.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não'
      }).then(result => {
        if(result.value){
          this.ocorrenciaService.Excluir(item.id).then(
            () => this.CarregarOcorrencias(),
            err => this.MostrarErro(err)
          );
        }
      });
    },
    VisualizarOcorrencia(item){
      this.ocorrenciaDetalhe = item;
      this.historico = [];
      this.ocorrenciaService.Historico(item.id).then(
        res => this.historico = res.data,
        err => this.MostrarErro(err)
      );
      this.dialogDetalhe = true;
    },
    async EnviarDocumento(id){
      const arquivo = await this.Ler(this.arquivoCarregar);
      return this.ocorrenciaService.EnviarDocumento(id, this.arquivoCarregar.name, arquivo);
    },
    Ler(arquivo) {
      return new Promise(resolve => {
        let fr = new FileReader();
        fr.onload = arquivo => resolve(arquivo.target.result);
        fr.readAsArrayBuffer(arquivo);
      });
    },
    DownloadDocumento(item){
      this.ocorrenciaService.DownloadDocumento(item.id, item.anexo);
    },
    DeletarDocumento(item){
      this.ocorrenciaService.DeletarDocumento(item.id, item.anexo).then(
        () => {
          item.anexo = '';
          this.ocorrencia.anexo = '';
        },
        err => this.MostrarErro(err)
      );
    },
    AbrirCadastroBeneficiario(){
      this.beneficiarioService.ObterPorId(this.resumoBeneficiario.id).then(
        res => {
          this.beneficiarioCadastro = new Beneficiario(res.data);
          this.dialogBeneficiario = true;
        },
        err => this.MostrarErro(err)
      );
    },
    MostrarErro(err){
      const data = err && err.response ? err.response.data : err;
      let mensagem = 'Não foi possível concluir a operação.';

      if(typeof data === 'string')
        mensagem = data;
      else if(data && data.errors){
        const mensagens = [];
        Object.keys(data.errors).forEach(campo => {
          const erros = Array.isArray(data.errors[campo]) ? data.errors[campo] : [data.errors[campo]];
          erros.filter(x => !!x).forEach(erro => mensagens.push(erro));
        });
        mensagem = mensagens.length > 0 ? mensagens.join('<br/>') : (data.title || mensagem);
      }
      else if(data && data.title)
        mensagem = data.title;
      else if(data && data.message)
        mensagem = data.message;

      this.$swal({
        title: 'Aviso',
        html: mensagem,
        icon: err && err.response && err.response.status == 400 ? 'warning' : 'error'
      });
    },
    DataNascimento(item){
      if(!item || !item.dataNascimentoFundacao)
        return '-';

      const data = new Date(item.dataNascimentoFundacao);
      return `${data.ddmmyyyy()} / ${item.idade || 0} anos`;
    },
    DataHora(value){
      if(!value)
        return '-';

      return new Date(value).toLocaleString('pt-BR');
    },
    ResumoDescricao(value){
      if(!value)
        return '-';

      return value.length > 180 ? `${value.substring(0, 180)}...` : value;
    },
    GravidadeNome(value){
      const gravidade = this.gravidades.find(x => x.id == value);
      return gravidade ? gravidade.nome : '';
    },
    GravidadeCor(value){
      if(value == 'A') return 'red darken-2';
      if(value == 'M') return 'orange darken-2';
      return 'green darken-2';
    }
  },
  mounted(){
    this.CarregarTipos();
  }
}
</script>

<style scoped>
.resumo-panel,
.tipo-panel {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 14px;
  background: #fbfcfd;
}

.resumo-foto {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef3f7;
  border-radius: 6px;
  margin-bottom: 10px;
}

.resumo-nome {
  font-size: 17px;
  font-weight: 700;
  color: #263238;
}

.resumo-linha {
  font-size: 13px;
  color: #607d8b;
  line-height: 1.7;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: #37474f;
}

.color-field-preview {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.18);
}

.tipo-lista {
  max-height: 360px;
  overflow-y: auto;
}

.tipo-actions {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.timeline-list {
  position: relative;
}

.timeline-item {
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 10px;
  margin-bottom: 12px;
}

.timeline-marker {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: 9px;
}

.timeline-content {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 12px;
  background: #ffffff;
}

.timeline-title {
  font-weight: 700;
  color: #263238;
  margin-top: 4px;
}

.timeline-subtitle {
  font-size: 12px;
  color: #78909c;
  margin-top: 2px;
}

.timeline-text {
  color: #455a64;
  margin-top: 8px;
  white-space: pre-line;
}
</style>
